import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-delete-account-verifyy',
  templateUrl: './delete-account-verifyy.component.html',
  styleUrls: ['./delete-account-verifyy.component.css']
})
export class DeleteAccountVerifyyComponent implements OnInit {
  api_success: string;
  api_error: any;
  delcount: any;
  accountType: any;
  btndisabled = true;
  loading: boolean;

  constructor(private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: number, private accountService: AccountService) { }

  ngOnInit() {
    this.delcount = this.data['count'];
    this.accountType = this.data['type'];
    // console.log(this.accountType);
    if (this.delcount > 0) {
      this.btndisabled = false;
    }
  }

  onDeleteConfirm() {
    this.btndisabled = true;
    this.loading = true;
    if (this.accountType === 'Account') {
      if (this.data['claimedStatus'] && this.data['claimedStatus'] === 'Unclaimed') {
       this.accountService.deleteUnclaimedAccounts(this.data['filter'])
       .subscribe(res => {
        this.loading = false;
        this.api_success = 'Account deletion in progress you will receive mail after deletion';
        this.btndisabled =  false;
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
       },
       (error) => {
        this.loading = false;
        this.api_error = error.error;
        this.btndisabled = false;
      }
       );
      } 

}
  }
}